import React from "react";

const AtIconUp = ({ width = "116", height = "73", className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 116 73"
      className={className}
    >
      <path
        fill="#F05223"
        stroke="#fff"
        strokeWidth="2.083"
        d="M64.66 4.431a9.397 9.397 0 0 0-3.056-2.17A8.94 8.94 0 0 0 58 1.5a8.94 8.94 0 0 0-3.604.762A9.397 9.397 0 0 0 51.34 4.43L4.258 54.428a10.064 10.064 0 0 0-2.041 3.244 10.541 10.541 0 0 0-.717 3.827c0 1.313.244 2.614.717 3.827a10.062 10.062 0 0 0 2.041 3.245 9.4 9.4 0 0 0 3.056 2.168 8.943 8.943 0 0 0 3.604.761 8.943 8.943 0 0 0 3.604-.761 9.4 9.4 0 0 0 3.055-2.168L58 25.646l40.423 42.925a9.395 9.395 0 0 0 3.055 2.168 8.944 8.944 0 0 0 3.604.761 8.94 8.94 0 0 0 3.604-.761 9.403 9.403 0 0 0 3.056-2.168 10.065 10.065 0 0 0 2.041-3.245c.473-1.213.717-2.513.717-3.827 0-1.313-.244-2.614-.717-3.827a10.067 10.067 0 0 0-2.041-3.244L64.659 4.43Z"
      />
    </svg>
  );
};

export default AtIconUp;
